var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M144.77 58.906c5.973 0 11.687 2.852 15.265 7.632l15.742 20.99h78.709c10.523 0 19.081 8.567 19.081 19.08v95.405c0 10.523-8.558 19.081-19.081 19.081H101.838c-10.523 0-19.081-8.558-19.081-19.08v-41.66h19.081v41.66h152.658l-.01-95.406h-78.71c-5.971 0-11.686-2.852-15.264-7.632l-15.742-20.99h-42.932v41.66H82.757v-41.66c0-10.513 8.558-19.08 19.081-19.08zM52.884 92.298l14.04 14.355-22.703 23.029h114.86v20.487H44.669l22.105 23.178-13.74 14.355L6.432 140.15z"
})));
export default SvgFolderOut;